module.exports = __webpack_public_path__ + "img/6.7680ff81.jpg";